// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DocGenerator_container__liD1I {
    max-width: 920px;
    margin: 0 auto;
    padding: 16px;
}

.DocGenerator_languageSelector__UNbRO {
    margin-bottom: 20px;
}

.DocGenerator_formSection__JXk-J {
    border: 1px solid var(--workspace-border);
    background: var(--mantine-color-body);
    border-radius: 7px;
    padding: 20px;
    margin-bottom: 20px;
}

.DocGenerator_formRow__UdIHX {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 20px;
    margin-bottom: 20px;
}

.DocGenerator_formGroup__Eo3E8 {
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.DocGenerator_dateInputs__DQWCN {
    display: flex;
    gap: 10px;
    align-items: center;
    flex-wrap: wrap;
    margin-bottom: 20px;
}

.DocGenerator_dateInputs__DQWCN select,
.DocGenerator_dateInputs__DQWCN input {
    flex: 1 1;
    min-width: 100px;
}

.DocGenerator_variantSection__cpmhO {
    display: flex;
    flex-direction: column;
    gap: 15px;
    align-items: center;
    margin: 20px 0;
}

.DocGenerator_uploadLabel__nrFxe {
    cursor: pointer;
    padding: 8px 16px;
    border: 1px solid var(--workspace-border);
    border-radius: 5px;
    color: var(--workspace-accent);
    font-weight: 500;
    transition: all 0.3s ease;
    text-align: center;
    display: inline-block;
}

.DocGenerator_uploadLabel__nrFxe:hover {
    background: var(--workspace-accent);
    color: white;
}

.DocGenerator_hiddenInput__Qrs6l {
    display: none;
}

.DocGenerator_generateButton__xDffK {
    width: 100%;
    margin-top: 20px;
}

.DocGenerator_canvasContainer__ZZ5sX {
    display: flex;
    justify-content: center;
    margin-top: 30px;
    padding: 16px;
    background: var(--mantine-color-gray-0);
    border-radius: 7px;
}

.DocGenerator_canvas__WPrnX {
    border: 1px solid var(--mantine-color-gray-3);
    border-radius: 5px;
    max-width: 100%;
    height: auto;
}

@media (max-width: 768px) {
    .DocGenerator_formRow__UdIHX {
        grid-template-columns: 1fr;
    }
    
    .DocGenerator_dateInputs__DQWCN {
        flex-direction: column;
    }
    
    .DocGenerator_dateInputs__DQWCN select,
    .DocGenerator_dateInputs__DQWCN input {
        width: 100%;
    }
}

.DocGenerator_dateInputs__DQWCN > * { min-width: 0; }
@media (max-width: 480px) { .DocGenerator_dateInputs__DQWCN { align-items: stretch; } .DocGenerator_dateInputs__DQWCN > * { width: 100%; } }
`, "",{"version":3,"sources":["webpack://./src/components/docgen/DocGenerator.module.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,cAAc;IACd,aAAa;AACjB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,yCAAyC;IACzC,qCAAqC;IACrC,kBAAkB;IAClB,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,aAAa;IACb,SAAS;IACT,mBAAmB;IACnB,eAAe;IACf,mBAAmB;AACvB;;AAEA;;IAEI,SAAO;IACP,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,yCAAyC;IACzC,kBAAkB;IAClB,8BAA8B;IAC9B,gBAAgB;IAChB,yBAAyB;IACzB,kBAAkB;IAClB,qBAAqB;AACzB;;AAEA;IACI,mCAAmC;IACnC,YAAY;AAChB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,gBAAgB;IAChB,aAAa;IACb,uCAAuC;IACvC,kBAAkB;AACtB;;AAEA;IACI,6CAA6C;IAC7C,kBAAkB;IAClB,eAAe;IACf,YAAY;AAChB;;AAEA;IACI;QACI,0BAA0B;IAC9B;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;;QAEI,WAAW;IACf;AACJ;;AAEA,sCAAkB,YAAY,EAAE;AAChC,4BAA4B,kCAAc,oBAAoB,EAAE,EAAE,sCAAkB,WAAW,EAAE,EAAE","sourcesContent":[".container {\n    max-width: 920px;\n    margin: 0 auto;\n    padding: 16px;\n}\n\n.languageSelector {\n    margin-bottom: 20px;\n}\n\n.formSection {\n    border: 1px solid var(--workspace-border);\n    background: var(--mantine-color-body);\n    border-radius: 7px;\n    padding: 20px;\n    margin-bottom: 20px;\n}\n\n.formRow {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    gap: 20px;\n    margin-bottom: 20px;\n}\n\n.formGroup {\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n}\n\n.dateInputs {\n    display: flex;\n    gap: 10px;\n    align-items: center;\n    flex-wrap: wrap;\n    margin-bottom: 20px;\n}\n\n.dateInputs select,\n.dateInputs input {\n    flex: 1;\n    min-width: 100px;\n}\n\n.variantSection {\n    display: flex;\n    flex-direction: column;\n    gap: 15px;\n    align-items: center;\n    margin: 20px 0;\n}\n\n.uploadLabel {\n    cursor: pointer;\n    padding: 8px 16px;\n    border: 1px solid var(--workspace-border);\n    border-radius: 5px;\n    color: var(--workspace-accent);\n    font-weight: 500;\n    transition: all 0.3s ease;\n    text-align: center;\n    display: inline-block;\n}\n\n.uploadLabel:hover {\n    background: var(--workspace-accent);\n    color: white;\n}\n\n.hiddenInput {\n    display: none;\n}\n\n.generateButton {\n    width: 100%;\n    margin-top: 20px;\n}\n\n.canvasContainer {\n    display: flex;\n    justify-content: center;\n    margin-top: 30px;\n    padding: 16px;\n    background: var(--mantine-color-gray-0);\n    border-radius: 7px;\n}\n\n.canvas {\n    border: 1px solid var(--mantine-color-gray-3);\n    border-radius: 5px;\n    max-width: 100%;\n    height: auto;\n}\n\n@media (max-width: 768px) {\n    .formRow {\n        grid-template-columns: 1fr;\n    }\n    \n    .dateInputs {\n        flex-direction: column;\n    }\n    \n    .dateInputs select,\n    .dateInputs input {\n        width: 100%;\n    }\n}\n\n.dateInputs > * { min-width: 0; }\n@media (max-width: 480px) { .dateInputs { align-items: stretch; } .dateInputs > * { width: 100%; } }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `DocGenerator_container__liD1I`,
	"languageSelector": `DocGenerator_languageSelector__UNbRO`,
	"formSection": `DocGenerator_formSection__JXk-J`,
	"formRow": `DocGenerator_formRow__UdIHX`,
	"formGroup": `DocGenerator_formGroup__Eo3E8`,
	"dateInputs": `DocGenerator_dateInputs__DQWCN`,
	"variantSection": `DocGenerator_variantSection__cpmhO`,
	"uploadLabel": `DocGenerator_uploadLabel__nrFxe`,
	"hiddenInput": `DocGenerator_hiddenInput__Qrs6l`,
	"generateButton": `DocGenerator_generateButton__xDffK`,
	"canvasContainer": `DocGenerator_canvasContainer__ZZ5sX`,
	"canvas": `DocGenerator_canvas__WPrnX`
};
export default ___CSS_LOADER_EXPORT___;
